export function ReconfirmDataIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M2.55234 2.55369C0.649219 4.45607 0.649219 7.54159 2.55234 9.44631L3.1875 10.0812V8.24912C3.1875 7.93752 3.43828 7.68684 3.75 7.68684C4.06172 7.68684 4.3125 7.93752 4.3125 8.24912V11.4377C4.3125 11.7493 4.06172 12 3.75 12H0.5625C0.250781 12 0 11.7493 0 11.4377C0 11.1261 0.250781 10.8754 0.5625 10.8754H2.39297L1.75781 10.2405C-0.585938 7.8977 -0.585938 4.09996 1.75781 1.75947C2.77031 0.747364 4.05703 0.171027 5.37891 0.0351425C5.68828 0.00234284 5.96484 0.227255 5.99531 0.536509C6.02578 0.845763 5.80312 1.12222 5.49375 1.15267C4.42031 1.26513 3.37734 1.73136 2.55234 2.55369ZM6.62109 11.9649C6.31172 11.9977 6.03516 11.7727 6.00469 11.4635C5.97422 11.1542 6.19688 10.8778 6.50625 10.8473C7.57969 10.7372 8.625 10.2686 9.44766 9.44631C11.3508 7.54393 11.3508 4.45841 9.44766 2.55369L8.8125 1.91878V3.75088C8.8125 4.06248 8.56172 4.31316 8.25 4.31316C7.93828 4.31316 7.6875 4.06248 7.6875 3.75088V0.56228C7.6875 0.250683 7.93828 0 8.25 0H11.4375C11.7492 0 12 0.250683 12 0.56228C12 0.873877 11.7492 1.12456 11.4375 1.12456H9.60703L10.2422 1.75947C12.5859 4.1023 12.5859 7.90004 10.2422 10.2405C9.22969 11.2526 7.94297 11.829 6.62109 11.9649Z"
        fill="var(--foreground-default, #101010)"
      />
    </svg>
  );
}
